module.exports = "<a href=\"javascript: void(0);\">{{$ctrl.linkText}}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpTextLink/adpTextLink.html
// module id = 573
// module chunks = 0